(function () {
  const root = document.querySelector('.pujh-dm');
  if (!root) return;

  document.documentElement.classList.add('pujh-dm-page');

  const hideRepeatedCompareControls = () => {
    const candidates = document.querySelectorAll('button, a, div, span');

    candidates.forEach((element) => {
      if (element.closest('.pujh-dm') && element.closest('.pujh-dm__compare')) return;

      const label = (element.textContent || '').replace(/\s+/g, ' ').trim();
      if (label !== 'Product comparison') return;

      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      const appWrapper = element.closest(
        '[class*="snap-compare"], [id*="snap-compare"], [class*="snap_compare"], [id*="snap_compare"], [class*="product-comparison"], [id*="product-comparison"]'
      );

      if (appWrapper || style.position === 'fixed' || style.position === 'sticky' || (rect.width < 100 && rect.height > 70)) {
        const target = appWrapper || element;
        target.style.setProperty('display', 'none', 'important');
        target.setAttribute('aria-hidden', 'true');
      }
    });
  };

  hideRepeatedCompareControls();

  const observer = new MutationObserver(hideRepeatedCompareControls);
  observer.observe(document.body, { childList: true, subtree: true });

  window.setTimeout(hideRepeatedCompareControls, 700);
  window.setTimeout(hideRepeatedCompareControls, 1800);
  window.setTimeout(() => observer.disconnect(), 10000);
})();
